<script lang="ts">
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let show: boolean = true;

  function close() {
    show = false;
  }
  let queryString = location.href.split("?")[1] || "";
  if (queryString !== "") {
    queryString = "?" + queryString;
  }

</script>

{#if show}
  <span class="fizz-styles">
    <Modal bind:show closeOnBackgroundClick={true} fizzModal={true} center={true} size={"medium"}>
      <section style="padding: 1.5rem 2rem;" class="fizz-text-center">
        <header class="fizz-space-between fizz-stack-32">
          <h4 class="fizz-heading-4">
            <Icon className={"fizz-margin-auto"} type="ProviLogo" height="45" width="150" />
          </h4>
          <button class="fizz-icon-button" id="close-payment-type-modal" on:click={close}>
            <Icon
              type="X"
              extraClassNames="fizz-text-brand cursor-pointer"
              height="16"
              width="16"
            />
          </button>
        </header>

        <section class="fizz-modal-main fizz-text-medium fizz-flow-16">
          <p class="fizz-heading-3 fizz-stack-8">Beverage ordering, made simple!</p>
          <p>
            Provi is your one stop shop for beverage ordering. Sign up today and save yourself
            countless hours!
          </p>
        </section>

        <div class="fizz-inset-squish-24">
          <a href={`/sign-up${queryString}`} class="fizz-button-secondary">Sign Up</a>
        </div>
        <div class="spacing-16">
          <strong><a href={`/users/sign_in${queryString}`}>Log In</a></strong>
        </div>
      </section>
    </Modal>
  </span>
{/if}
